<template>
  <nav class="navigation-secondaire" id="navigation-secondaire">
    <ul class="container nav-secondaire">
      <li v-for="(metier, index) in tabMetier" :key="metier.id_gmetier" class="item-nav">
        <a
          :id="index"
          @click="focusCurrent(index, metier.cod_met)"
          :class="{ 'link-metier': true, current: selectedCodMet === metier.cod_met }"
          :title="metier.com_met"
          ref="focusableElements"
        >
          <i class="icon" :class="metier.ico_met"></i>
          <span>{{ metier.lib_met }}</span>
        </a>
      </li>
    </ul>
  </nav>
  <figure v-if="!isMobile" class="banner-pl">
    <img src="../assets/jpg/banner-pl.jpg" alt="Magasin poid-lourds" />
  </figure>
  <!-- <figure v-if="!isMobile" class="banner-conso">
    <img src="../assets/jpg/banner-consommables.jpg" alt="Magasin consommables" />
  </figure> -->
</template>
<script>
import Swal from "sweetalert2";
export default {
  name: "navigationSecondaire",
  data() {
    return {
      tabMetier: [],
      selectedCodMet: "", // 0 index par defaut pour mettre le current dessus puis Pour suivre l'élément actuellement sélectionné
      urlApi: process.env.VUE_APP_API_URL,
      isMobile:false,
      acces:'N'
    };
  },
  created() {
    this.listeMetier();
  },
  mounted() {
    this.selectedMetier = Number(this.$route.query.index) || 0;
    this.selectedCodMet = this.$sessionStorage.get("cod_met") || "VL";
  },
  methods: {
    checkScreenSize() {
      const screenWidth = window.innerWidth;
      this.isMobile = screenWidth < 899;
    },
    async listeMetier() {
      const i_id_gadherent = this.$sessionStorage.get("id_gadherent");
      var i_instance = this.$sessionStorage.get("instance");
      const i_id_adhcli = this.$sessionStorage.get("id_adhcli");
      const vphpsid = this.$sessionStorage.get("vphpsid");
      const urlApi = this.urlApi;
      const sessionData = {
        instance: i_instance,
        id_gadherent: i_id_gadherent,
        id_adhcli: i_id_adhcli,
        vphpsid: vphpsid
      };
      try {
        const response = await fetch(`${urlApi}/api/listeMetier`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sessionData),
        });
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        this.tabMetier = data;
        const codMetSession = this.$sessionStorage.get("cod_met");
        const codMetRoute = this.$route.name ? this.$route.name.replace("portail", "") : "";
        const codMetTrouve = data.find((metier) => metier.cod_met === codMetSession)
          ? codMetSession
          : data.find((metier) => metier.cod_met === codMetRoute)
            ? codMetRoute
            : data[0]?.cod_met || "";

      this.selectedCodMet = codMetTrouve;
      this.selectedMetier = data.findIndex((metier) => metier.cod_met === codMetTrouve);
      this.$sessionStorage.set("cod_met", codMetTrouve);
        const hasPne = Array.isArray(data) && data.some((metier) => metier.cod_met === 'PNE');
        this.$sessionStorage.set('hasPneMetier', hasPne ? 'O' : 'N');
      } catch (e) {}
    },
    focusCurrent(index, cod_met) {
      document.body.classList.remove("open");
      // Retirer la classe 'current' de l'élément actif précédent
      // const elementCurrent = document.querySelector(".current");
      // if (elementCurrent) {
      //   document.querySelector(".current").classList.remove("current");
      //   document.body.classList.remove("open");
      // }
      this.selectedCodMet = cod_met;
      this.$store.commit('setgCod_metDefaut',cod_met);
      this.$sessionStorage.set("cod_met", cod_met);
      //this.$router.push({ name: "portail" + cod_met, query: { index: index } });

      switch (cod_met) {
        case 'VL':
          this.acces='O';
          const plaque = this.$sessionStorage.get("plaque");
          // if (plaque) {
          //   this.$router.push({ name: "categorieTecdoc", query: { index } });
          // } else {
          //   this.$router.push('/portailVL');
          // }

          if (plaque) {
            // Si une plaque existe déjà, on la conserve et on redirige vers categorieTecdoc
            this.$store.commit("setgImmat", plaque);
            this.$sessionStorage.set("plaque", plaque);
            this.$store.commit("setgTyp", "I");
            this.$store.commit("setgParentNodeIdNavigation", "0");
            this.$router.push({ name: "categorieTecdoc", query: { index } });
            return;
          } else {
            // Sinon, on reste sur portailVL avec l’index pour affichage propre
            this.$router.push({ name: "portailVL", query: { index } });
            return;
          }
          break;

        case 'PL':
          this.acces='O';
          // this.acces='N';
          // this.$swal.fire({
          //   icon: 'success',
          //   title: 'Ouverture prochaine.',
          //   showCloseButton: true,
          //   allowOutsideClick: false
          // });
          break;
        
        case 'CARRO':
          this.acces='O';
          // this.acces='N';
          // this.$swal.fire({
          //   icon: 'success',
          //   title: 'Ouverture prochaine.',
          //   showCloseButton: true,
          //   allowOutsideClick: false
          // });
          break;

        case 'OUT':
            this.acces='O';
        break;
        case 'CONSO':
            this.acces='O';
        break;

        case 'MAT':
            this.acces='O';
        break;
        
        case 'EPI':
          this.acces='O';
          // this.acces='N';
          // this.$swal.fire({
          //   icon: 'success',
          //   title: 'Ouverture prochaine.',
          //   showCloseButton: true,
          //   allowOutsideClick: false
          // });
          break;
        
        case 'PNE':
          this.acces='O';
          // this.$swal.fire({
          //   icon: 'success',
          //   title: 'Ouverture prochaine.',
          //   showCloseButton: true,
          //   allowOutsideClick: false
          // });
          break;

        default:
          console.warn('Metier inconnu ou non pris en charge :', cod_met);
          break;
      }
      // ACCES AU PORTAIL 
      if (cod_met && this.acces==='O'){
          // this.$swal.fire({
          //     icon: 'success',
          //     title: 'Ouverture prochaine11.',
          //     showCloseButton: true,
          //     allowOutsideClick: false,
          //     }).then(() => {
          // });
          this.$router.push({ name: "portail" + cod_met, query: { index: index } });
          return ;
      } else {
          console.error('cod_met is undefined or null');
      }
    },
  },
};
</script>
